const FOCUS_OUTLINE_CSS_CLASS = 'addFocusOutline';
const NAVIGATION_KEYS = ['Tab'];
const ARROW_KEYS = ['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp'];

function removeFocusOutlines(this: HTMLBodyElement, ev: MouseEvent) {
    this.classList.remove(FOCUS_OUTLINE_CSS_CLASS);
}

function isTextInput(element: HTMLElement) {
    return (
        element.tagName == 'INPUT' ||
        element.tagName == 'TEXTAREA' ||
        (element.contentEditable && element.contentEditable == 'true')
    );
}

function addFocusOutlinesIfNeeded(this: HTMLBodyElement, ev: KeyboardEvent) {
    if (
        NAVIGATION_KEYS.indexOf(ev.key) >= 0 ||
        (ARROW_KEYS.indexOf(ev.key) >= 0 && !isTextInput(ev.target as HTMLElement))
    ) {
        this.classList.add(FOCUS_OUTLINE_CSS_CLASS);
    } else if (isTextInput(ev.target as HTMLElement)) {
        this.classList.remove(FOCUS_OUTLINE_CSS_CLASS);
    }
}

export default function initializeFocusOutline() {
    document.body.addEventListener('mousedown', removeFocusOutlines, true);
    document.body.addEventListener('keydown', addFocusOutlinesIfNeeded, true);
}
